export const Links = {
    HOME: '/',
    WORK: '/our-work',
    ABOUT: '/about',
    CONTACT: '/contact',

    // IDs
    ESTIMATE_CARD: '#estimate',

    // Cases
    CASE_RIDE_HAILING: '/case-study/ride-hailing',
    CASE_BEND_IN_TREND: '/case-study/bendintrend',
    CASE_JINNAH_HOSPITAL: '/case-study/jinnah-hospital',
    CASE_STITCH_IT: '/case-study/stitch-it',
    CASE_SPLITCEIPT: 'https://splitceipt.com/',
    CASE_BEACON_INVESTMENT: 'https://play.google.com/store/apps/details?id=org.beaconinvestment.android&hl=en',
    CASE_LAHORE_BARIATRICS: 'https://drfarooqrana.com/',
    CASE_WOW_ION: 'https://wowion.com',

    // Misc
    EMAIL: 'hello@firebits.dev',
    EMAIL_LINK: 'mailto:hello@firebits.dev'
};

export default {}